<ng-container *ngIf="days$ | async as days">
  <pr-day *ngFor="let day of days; trackBy: trackByDay" fxFlex [day]="day" />
</ng-container>
